export default {
  getUnderStaff: "/employee/subordinateemployee", //获取下属员工列表
  getcheckin: "/attendance/getcheckin/{id}", //根据员工id获取工作台打卡记录API
  getcheckininfo: "/attendance/getcheckininfo", //根据考勤id获取当天打卡详情API
  getApprovallist: "/workbench/getapprovallist", //获取审批列表
}



// WEBPACK FOOTER //
// ./src/api/config/workTable.js